"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurveyDemographicsUpdatedSchema = void 0;
const enums_1 = require("./enums");
const zod_1 = require("zod");
const DemographicsBreakdown = zod_1.z.array(zod_1.z.object({
    // this looks like it may be an enum that doesn't exist yet(Demographics.Gender.type...)
    type: zod_1.z.string(),
    breakdowns: zod_1.z.array(zod_1.z.object({
        // the same non-existing enum
        bucket: zod_1.z.string(),
        respondentSelfReportedPercent: zod_1.z.number(),
        respondentThirdPartyPercent: zod_1.z.number(),
        communityPercent: zod_1.z.number().nullish(),
    })),
}));
exports.SurveyDemographicsUpdatedSchema = zod_1.z.object({
    type: zod_1.z.literal(enums_1.MessageType.SurveyDemographics.Updated),
    version: zod_1.z.string(),
    payload: zod_1.z.object({
        surveyId: zod_1.z.string().uuid(),
        demographics: DemographicsBreakdown,
    }),
});
